import React from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { ProducerLogo } from '../../components/icons/producer-logo';
import { PagePlaceholder } from '../../components/page-placeholder/page-placeholder';

import styles from './thanks.page.module.scss';
export const MarketplaceThanksPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const spaceId = searchParams.get('spaceId');

  return (
    <div className={styles['container']}>
      <div className={styles['logo']}>
        <ProducerLogo />
      </div>

      <PagePlaceholder
        description="Thank you for subscription"
        actionButton={{
          text: 'Continue to PRODUCER',
          onClick: () => (spaceId ? navigate(`/space/${spaceId}`) : navigate('/')),
        }}
      />
    </div>
  );
};
